import React from "react";
import { Card, Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
import { CHANGELOG_PATH, DOCS_BASE_PATH, ORGANIZATION_PATH } from "../../../router/RouterUtils";
import { ExternalLink } from "lucide-react";

const DashboardQuickLinks = () => {
  return (
    <Card>
      <div className="p-4 border-b border-gray-10 flex items-center">
        <Text variant="h5">Quick links</Text>
      </div>
      <div className="p-4 flex flex-col gap-y-2">
        <Button
          variant={ButtonVariant.TextBlue}
          onClick={() => window.open(CHANGELOG_PATH, "_blank")}
          className="px-0"
          rightIcon={<ExternalLink size={16} />}
        >
          Changelog
        </Button>
        <Button
          variant={ButtonVariant.TextBlue}
          onClick={() => window.open(DOCS_BASE_PATH, "_blank")}
          className="px-0"
          rightIcon={<ExternalLink size={16} />}
        >
          API docs
        </Button>
        <Button
          variant={ButtonVariant.TextBlue}
          onClick={() => window.open(ORGANIZATION_PATH, "_blank")}
          className="px-0"
          rightIcon={<ExternalLink size={16} />}
        >
          Manage users
        </Button>
      </div>
    </Card>
  );
};

export default DashboardQuickLinks;
